<template>
<div class="global-filters" >
  <el-form>
    <el-form-item label="Métier" >
      <template slot="label" >
        Métier
        <el-tooltip
          class="item"
          placement="right"
          content="Code ROME, appellation ROME, ou FAP"
          effect="dark" >
          <i class="el-icon-fa-info-circle" />
        </el-tooltip>
      </template>
      <el-select
        v-model="tradeSelection"
        value-key="id"
        :multiple="true"
        :filterable="true"
        :remote="true"
        :remote-method="query => autocompleteFilter('trade', query)"
        :loading="tradeLoading"
        @change="evt => handleChange()" >
        <el-option
          v-for="r in trades"
          :key="r.id"
          :label="format(r)"
          :value="r" />
      </el-select>
    </el-form-item>
    <el-form-item label="Lieu" >
      <template slot="label" >
        Lieu
        <el-tooltip
          class="item"
          placement="right"
          content="Région, département ou zone d'emploi"
          effect="dark" >
          <i class="el-icon-fa-info-circle" />
        </el-tooltip>
      </template>
      <el-select
        v-model="geoSelection"
        value-key="id"
        :multiple="true"
        :filterable="true"
        :remote="true"
        :remote-method="query => autocompleteFilter('geo', query)"
        :loading="geoLoading"
        @change="evt => handleChange()" >
        <el-option
          v-for="r in geos"
          :key="r.id"
          :label="format(r)"
          :value="r" />
      </el-select>
      <el-form-item class="global-date" label="Date" >
        <year-range-select v-model="dates" ref="dates" @change="handleChange" />
      </el-form-item>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import {api} from 'macarons'
import YearRangeSelect from './YearRangeSelect'

export default {
  components: {
    YearRangeSelect
  },
  data () {
    return {
      loading: false,
      trades: [],
      tradeSelection: [],
      tradeLoading: false,
      geos: [],
      geoSelection: [],
      geoLoading: false,
      dates: null
    }
  },
  computed: {
    filters () {
      return Array.from(new Set(
        this.tradeSelection.reduce((acc, trade) => acc.concat(trade.filters), []).concat(
          this.geoSelection.reduce((acc, geo) => acc.concat(geo.filters), [])
        )
      )).concat(this.dates ? this.dates.values : [])
    }
  },
  created () {
    this.$store.commit('customGraph/addEventListener', {
      event: 'executeQuery',
      handler: this.onPreExecuteQuery
    })
    this.$store.commit('customGraph/addEventListener', {
      event: 'DSNQuery',
      handler: this.onPreDSNQuery
    })
  },
  mounted () {
    this.loadFilters()
  },
  beforeDestroy () {
    this.$store.commit('customGraph/removeEventListener', {
      event: 'executeQuery',
      handler: this.onPreExecuteQuery
    })
    this.$store.commit('customGraph/removeEventListener', {
      event: 'DSNQuery',
      handler: this.onPreDSNQuery
    })
  },
  methods: {
    loadFilters () {
      if (window.location.hash.match(/^.*filters=\d+.*$/)) {
        const query = this.$router.currentRoute.query
        this.loading = true
        if (!query.filters) {
          this.$nextTick(this.loadFilters)
        } else {
          api.post('proxy/load-filters', {
            filters: query.filters.split(',').filter(f => f && !f.startsWith('[')),
            withChildren: ['trade']
          }).then(({ data }) => {
            this.trades.splice(0, this.trades.length, ...data.filter(f => f.type === 'trade'))
            this.tradeSelection.splice(0, this.tradeSelection.length, ...this.trades)
            this.geos.splice(0, this.geos.length, ...data.filter(f => f.type === 'geo'))
            this.geoSelection.splice(0, this.geoSelection.length, ...this.geos)
            const dates = query.filters.split(',').find(f => f.startsWith('['))
            if (dates) {
              this.$refs.dates.setRange(JSON.parse(dates.replace('-', ','))).then(() => {
                this.loading = false
                this.handleChange()
              })
            } else {
              this.loading = false
              this.handleChange()
            }
          })
        }
      }
    },
    onPreDSNQuery (event) {
      if (event.event !== 'DSNQuery') {
        return
      }
      if (event.query.route.substring(0, 17) !== 'ExecuteQueryExcel') {
        return
      }
      event.query.filters.splice(event.query.filters.length, 0, ...this.filters)
    },
    onPreExecuteQuery (event) {
      if (event.event !== 'executeQuery') {
        return
      }
      event.query.filters.splice(event.query.filters.length, 0, ...this.filters)
    },
    autocompleteFilter (type, query) {
      this[`${type}Loading`] = true
      api.post('proxy/autocomplete', {
        type: type,
        query: query,
        limit: 10,
        withChildren: type === 'trade',
        withParents: type === 'geo',
        restrictedTo: type === 'trade' ? [] : [
          '[Département].[Région].&[Bourgogne-Franche-Comté]',
          '[Département].[Région].&[Centre-Val de Loire]'
        ]
      }).then(({ data }) => {
        this[`${type}s`].splice(0, this[`${type}s`].length, ...data)
        this[`${type}Loading`] = false
      })
    },
    handleChange () {
      if (this.loading) {
        return
      }
      this.$router.push({
        name: this.$router.currentRoute.name,
        query: {
          filters: this.tradeSelection.concat(this.geoSelection).map(t => t.id).concat(
            this.dates ? [JSON.stringify(this.dates.range).replace(',', '-')] : []
          ).join(',')
        }
      })
      this.$store.commit('setGlobalFilters', this.filters)
      this.$store.dispatch('track', {
        action: 'change-filters',
        data: { filters: this.filters }
      })
      if (['home-board', 'board-chloe'].indexOf(this.$router.currentRoute.name) === -1) {
        this.$router.push('/home')
      } else if (!this.filters.length && this.$router.currentRoute.name !== 'home-board') {
        this.$router.push('/home')
      } else if (this.filters.length && this.$router.currentRoute.name === 'home-board') {
        this.$store.dispatch('loadBoard').then(() => {
          this.$store.dispatch('getBoardAccess', this.$store.state.board.id).then(access => {
            if (access) {
              this.$router.push({
                path: '/boards/' + this.$store.state.board.id,
                query: {
                  filters: this.tradeSelection.concat(this.geoSelection).map(t => t.id).join(',')
                }
              })
            }
          })
        })
      }
      this.$store.dispatch('customGraph/emitEvent', { event: 'refresh' })
    },
    format (filter) {
      return `${filter.filters[0].match(/^\[[^\]]+\]\.\[([^\]]+)\].*$/)[1]}: ${filter.text}`
    }
  }
}
</script>

<style scoped>
.el-select >>> .el-tag {
    max-width: 90%;
}
.el-select >>> .el-select__tags-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 90%;
}
.el-select >>> .el-tag__close {
    top: -7px;
}
.el-form-item >>> .el-form-item__label {
    display: block;
    text-align: left;
    float: none;
}
.global-date >>> .global-date-filter {
    padding: 0 20px;
}

.global-date >>> .range-filter__placeholder {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/macarons/components/GlobalFiltersv2.vue